import { Fragment, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogPanel,
  Popover,
  Transition,
} from "@headlessui/react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonThird from "shared/Button/ButtonThird";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import Checkbox from "shared/Checkbox/Checkbox";
import convertNumbThousand from "utils/convertNumbThousand";
import Slider from "rc-slider";

// DEMO DATA
const typeOfCar = [
  { name: "Small", description: "$68" },
  { name: "Medium", description: "$128" },
  { name: "Large", description: "$268" },
  { name: "SUV", description: "$268" },
  { name: "Van", description: "$268" },
  { name: "Luxury", description: "$268" },
];

const carSpecifications = [
  { name: "With air conditioning" },
  { name: "Automatic transmission" },
  { name: "Manual transmission" },
  { name: "2 doors" },
  { name: "4+ doors" },
];

//
const mileage = [{ name: "Unlimited" }, { name: "Limited" }];
const supplier = [
  { name: "Alamo", defaultChecked: true },
  { name: "Avis", defaultChecked: true },
  { name: "Budget" },
  { name: "Dollar" },
];
const insurance = [
  { name: "No insurance", defaultChecked: true },
  { name: "Zero excess " },
  { name: "Inclusive" },
];

const TabFilters = ({
  types,
  selectedTypes,
  setSelectedTypes,
  rangePrices,
  setRangePrices,
  maxPrice,
}: {
  types: string[];
  selectedTypes: string[];
  setSelectedTypes: any;
  rangePrices: number[];
  setRangePrices: any;
  maxPrice: number;
}) => {
  const [selectedAllTypes, setSelectedAllTypes] = useState<boolean>(false);
  const [isOpenMoreFilter, setisOpenMoreFilter] = useState(false);
  const [isOpenMoreFilterMobile, setisOpenMoreFilterMobile] = useState(false);
  const [isOnSale, setIsOnSale] = useState(true);
  //
  const closeModalMoreFilter = () => setisOpenMoreFilter(false);
  const openModalMoreFilter = () => setisOpenMoreFilter(true);
  //
  const closeModalMoreFilterMobile = () => setisOpenMoreFilterMobile(false);
  const openModalMoreFilterMobile = () => setisOpenMoreFilterMobile(true);

  const renderXClear = () => {
    return (
      <span className="w-4 h-4 rounded-full bg-primary-500 text-white flex items-center justify-center ml-3 cursor-pointer">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-3 w-3"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </span>
    );
  };

  const renderTabsTypeOfCars = () => {
    return (
      <Popover className="relative">
        {({ open, close }) => (
          <>
            <Popover.Button
              className={`flex items-center justify-center px-4 py-2 text-sm rounded-full border border-secondary-100 hover:border-primary-200 focus:outline-none bg-card-color text-text-color ${
                open ? "!border-primary-6000 " : ""
              }`}
            >
              <span>Car type</span>
              <i className="las la-angle-down ml-2"></i>
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute z-10 w-screen max-w-sm px-4 mt-3 sm:left-0 lg:left-auto lg:right-0 md:right-0 md:left-auto sm:px-0">
                <div className="overflow-hidden rounded-xl shadow-xl bg-card-color border border-secondary-100">
                  <div className="relative flex flex-col px-5 py-6 space-y-5">
                    <div key={"Select All"} className="">
                      <Checkbox
                        name="Select All"
                        label="Select All"
                        defaultChecked={selectedAllTypes}
                        onChange={(checked) => {
                          setSelectedAllTypes(checked);
                          setSelectedTypes(checked ? types : []);
                        }}
                      />
                    </div>

                    {types.map((type) => (
                      <div key={type} className="">
                        <Checkbox
                          name={type}
                          label={type}
                          defaultChecked={selectedTypes.includes(type)}
                          onChange={(checked) => {
                            if (checked) {
                              setSelectedTypes([...selectedTypes, type]);
                              if (selectedTypes.length + 1 === types.length) {
                                setSelectedAllTypes(true); // All types are selected
                              }
                            } else {
                              setSelectedTypes(
                                selectedTypes.filter((t) => t !== type)
                              );
                              setSelectedAllTypes(false); // Deselect 'Select All' if any type is unchecked
                            }
                          }}
                        />
                      </div>
                    ))}
                  </div>
                  <div className="p-5 bg-card-color border-t border-secondary-100 flex items-center justify-between">
                    <ButtonThird
                      onClick={() => {
                        setSelectedAllTypes(true);
                        setSelectedTypes([]);
                      }}
                      sizeClass="px-4 py-2 sm:px-5"
                    >
                      Clear
                    </ButtonThird>
                    <ButtonPrimary
                      onClick={close}
                      sizeClass="px-4 py-2 sm:px-5"
                    >
                      Close
                    </ButtonPrimary>
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    );
  };

  const renderTabsPriceRage = () => {
    return (
      <Popover className="relative">
        {({ open, close }) => (
          <>
            <Popover.Button
              className={`flex items-center justify-center px-4 py-2 text-sm rounded-full border border-secondary-100 hover:border-primary-200 focus:outline-none bg-card-color text-text-color ${
                open ? "!border-primary-6000 " : ""
              }`}
            >
              <span>
                {`$${convertNumbThousand(
                  rangePrices[0]
                )} - $${convertNumbThousand(rangePrices[1])}`}{" "}
              </span>
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute z-10 w-screen max-w-sm px-4 mt-3 sm:left-0 lg:left-auto lg:right-0 md:right-0 md:left-auto sm:px-0">
                <div className="overflow-hidden rounded-xl shadow-xl bg-card-color border border-secondary-100">
                  <div className="relative flex flex-col px-5 py-6 space-y-8">
                    <div className="space-y-5">
                      <span className="font-medium">Price per day</span>
                      <Slider
                        range
                        className="text-primary-6000"
                        min={0}
                        max={maxPrice}
                        value={rangePrices}
                        allowCross={false}
                        onChange={(e) => setRangePrices(e as number[])}
                      />
                    </div>

                    <div className="flex justify-between space-x-5">
                      <div>
                        <label
                          htmlFor="minPrice"
                          className="block text-sm font-medium text-text-color"
                        >
                          Min price
                        </label>
                        <div className="mt-1 relative rounded-md">
                          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <span className="text-neutral-500 sm:text-sm">
                              $
                            </span>
                          </div>
                          <input
                            type="text"
                            name="minPrice"
                            id="minPrice"
                            className="focus:ring-primary-200 focus:border-primary-300 block w-full pl-7 pr-3 sm:text-sm border-secondary-100 rounded-full bg-card-color text-text-color"
                            value={rangePrices[0]}
                            onChange={(e) =>
                              setRangePrices([+e.target.value, rangePrices[1]])
                            }
                          />
                        </div>
                      </div>
                      <div>
                        <label
                          htmlFor="maxPrice"
                          className="block text-sm font-medium text-text-color"
                        >
                          Max price
                        </label>
                        <div className="mt-1 relative rounded-md">
                          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <span className="text-neutral-500 sm:text-sm">
                              $
                            </span>
                          </div>
                          <input
                            type="text"
                            name="maxPrice"
                            id="maxPrice"
                            className="focus:ring-primary-200 focus:border-primary-300 block w-full pl-7 pr-3 sm:text-sm border-secondary-100 rounded-full bg-card-color text-text-color"
                            value={rangePrices[1]}
                            onChange={(e) =>
                              setRangePrices([rangePrices[0], +e.target.value])
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="p-5 bg-card-color border-t border-secondary-100 flex items-center justify-between">
                    <ButtonThird
                      onClick={() => setRangePrices([0, maxPrice])} // Set slider to max on clear
                      sizeClass="px-4 py-2 sm:px-5"
                    >
                      Clear
                    </ButtonThird>
                    <ButtonPrimary
                      onClick={close}
                      sizeClass="px-4 py-2 sm:px-5"
                    >
                      Close
                    </ButtonPrimary>
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    );
  };

  const renderMoreFilterItem = (
    data: {
      name: string;
      description?: string;
      defaultChecked?: boolean;
    }[]
  ) => {
    return (
      <div className="grid grid-cols-2 gap-y-7 gap-x-4 sm:gap-8">
        <div key={"Select All"} className="">
          <Checkbox
            name="Select All"
            label="Select All"
            defaultChecked={selectedAllTypes}
            onChange={(checked) => {
              if (checked) {
                setSelectedAllTypes(true);
                setSelectedTypes(types);
              } else {
                setSelectedAllTypes(false);
                setSelectedTypes([]);
              }
            }}
          />
        </div>

        {types.map((item) => (
          <div key={item} className="">
            <Checkbox
              name={item}
              label={item}
              defaultChecked={selectedTypes.includes(item)}
              onChange={(checked) => {
                if (checked) {
                  setSelectedTypes([...selectedTypes, item]);
                  if (selectedTypes.length + 1 == types.length) {
                    setSelectedAllTypes(true);
                  }
                } else {
                  setSelectedTypes([
                    ...selectedTypes.filter((item) => item != item),
                  ]);
                  setSelectedAllTypes(false);
                }
              }}
            />
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="flex lg:space-x-4">
      <div className="hidden lg:flex space-x-4">
        {renderTabsTypeOfCars()}
        {renderTabsPriceRage()}
        {/* {renderTabsGuestsAndBags()}
        {renderTabMoreFilter()} */}
      </div>
      <div className="flex-col lg:hidden space-y-4">
        {renderTabsTypeOfCars()}
        {renderTabsPriceRage()}
        {/* {renderTabMobileFilter()} */}
        {/* {renderTabOnSale()} */}
      </div>
    </div>
  );
};

export default TabFilters;
